import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../lib/dialog';

import useTwilioLogic from './useTwilioLogic';
import CallInfo from './CallInfo';
import IncomingInfo from './CallInfo/IncomingInfo';
import FunctionalButtons from './Buttons/FunctionalButtons';
import CallButtons from './Buttons/CallButtons';

const TwilioWidget: React.FC = () => {
    const {
        caseData,
        ongoingCall,
        handleOutgoingCall,
        showKeys,
        setShowKeys,
        showRingingDots,
        showIncomingCall,
        startTimer,
        showDuration,
        isMuted,
        toggleMuteMicrophone,
        isTwilioWidgetOpen,
        setIsTwilioWidgetOpen
    } = useTwilioLogic();

    const { phone, name, claimant_full_name } = caseData || {};

    if (!phone) return null;

    const personName: string = claimant_full_name || name;
    const incomingInfoProps = {
        phone: `${phone}`,
        personName
    };
    const callInfoProps = {
        ...incomingInfoProps,
        call: ongoingCall?.call,
        showRingingDots,
        startTimer,
        showDuration,
        showKeys
    };
    const functionalBtnsProps = {
        ongoingCall,
        showKeys,
        setShowKeys,
        isMuted,
        toggleMuteMicrophone
    };
    const callBtnsProps = {
        ongoingCall,
        handleOutgoingCall,
        setIsOpen: setIsTwilioWidgetOpen,
        showIncomingCall
    };

    return (
        <Dialog open={isTwilioWidgetOpen} onOpenChange={setIsTwilioWidgetOpen} modal={false}>
            <DialogContent
                className="right-2 bottom-2 left-auto top-auto w-90 z-[99999] text-white translate-x-0 translate-y-0 border-0"
                onInteractOutside={(e) => e.preventDefault()}
                onEscapeKeyDown={(e) => e.preventDefault()}
            >
                <DialogHeader className="hidden">
                    <DialogTitle>Twilio widget</DialogTitle>
                    <DialogDescription>Twilio widget for phone communication</DialogDescription>
                </DialogHeader>
                <div className="bg-black/85 rounded-tl-lg rounded-tr-lg backdrop-blur-md p-4">
                    {showIncomingCall && <IncomingInfo {...incomingInfoProps} />}
                    {!showIncomingCall && <CallInfo {...callInfoProps} />}
                </div>
                <div className="flex align-middle justify-between gap-x-2 bg-black/90 rounded-br-lg rounded-bl-lg backdrop-blur-md p-4">
                    <FunctionalButtons {...functionalBtnsProps} />
                    <CallButtons {...callBtnsProps} />
                </div>
            </DialogContent>
        </Dialog>
    );
};
export default TwilioWidget;
